// ** React Imports
import {Fragment, useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import '@styles/react/apps/app-email.scss'
import {
    Button,
    Card,
    Col,
    Row
} from "reactstrap"
import DataTable from "react-data-table-component"
import {Edit, MoreVertical} from "react-feather"
import {Link, useHistory} from "react-router-dom"
import axios from "axios";

import {getUserData} from "../../../utility/Utils";
import {usePrevious} from "../../../usePrevious";
import CustomHeader from "../../CustomHeader";
import {getCurrentOrganisationName} from "../../../utility/UserUtility";

export const ADMIN = "admin";
export const SUPER_ADMIN = "super_admin";

const Organisations = () => {

    let user = getUserData();
    const history = useHistory();
    const [data, setData] = useState([]);
    const [dataFetched, setDataFetched] = useState(false);
    const dispatch = useDispatch();


    const fetchFreshData = () => {
        let url = `${process.env.REACT_APP_MAIN_URL}/admin/organisations`;
        let organisation = getCurrentOrganisationName()
        url += `?org=${organisation}`
        axios.get(url).then((result) => {
            setData(result.data.organisations);
        })
    }

    // ** Get data on mount
    useEffect(() => {
        if (!dataFetched) {
            setDataFetched(true)
            fetchFreshData();
        }
    })

    const columns = [
        {
            name: 'Naziv',
            selector: 'name',
            sortable: true
        },
        {
            name: '',
            sortable: true,
            cell: ((row) => {
                return (
                    <Edit onClick={() => {
                        dispatch({
                            type: "CURRENT_ORGANISATION",
                            currentOrganisation: row
                        });
                        history.push(`/upravljanje/organizacije/detalji-organizacije/${row._id}`)
                    }} style={{cursor: "pointer", marginLeft: "60%"}} size={14} className='w-100'/>
                );
            })
        },


    ]

    return (
        <Fragment>
            <div style={{minWidth: "90%", overflow: scroll}} className='app-user-list'>
                <Card style={{
                    overflowY: "scroll"
                }}>
                    <DataTable
                        noHeader
                        subHeader
                        responsive
                        columns={columns}
                        className='react-dataTable'
                        data={data}
                        subHeaderComponent={
                            <CustomHeader
                                superAdminOnly
                                new={"Nova organizacija"}
                                onClick={() => {
                                    history.push("/upravljanje/organizacije/detalji-organizacije");
                                }
                                }
                            />
                        }
                    />
                </Card>
            </div>
        </Fragment>
    )
}

export default Organisations;
